module.exports = __webpack_public_path__ + "img/img (59).1281d70f.jpg";